import React from "react";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";

import { NEWSLETTER_PACKAGES } from "shared/data/newsletter";

import IconEmail from "./icon-email.svg";
import { Container, SubTitle, Title } from "./styles";

type Props = {
  className?: string;
};

export const TitleDisplay: React.FunctionComponent<Props> = ({ className }) => {
  const { packageDisplayName = "", packageKey } = useNewsletterContext();

  const targetNewsletterPackage = packageKey ? NEWSLETTER_PACKAGES[packageKey] : null;
  const isBundle = (targetNewsletterPackage?.childNewsletterIds ?? []).length > 1;

  return (
    <Container className={className}>
      <Title>
        <IconEmail />
        NEWSLETTER {isBundle && "BUNDLE"}
      </Title>
      <SubTitle>{packageDisplayName}</SubTitle>
    </Container>
  );
};

TitleDisplay.displayName = "TitleDisplay";
